function capitalizeFirstLetter(string) {
    if (!string) return ''
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export function processLangFiles(modules) {
    const otherLang = {}
    let base = {}

    for (const [path, moduleContent] of Object.entries(modules)) {
        const fileName = path.substring(path.lastIndexOf('/') + 1).replace(/\.\w+$/, '')
        const componentName = capitalizeFirstLetter(fileName)
        const componentConfig = moduleContent || {}

        if (componentName.toLowerCase() === 'base') {
            base = { ...componentConfig}
        }
        if (componentConfig.route) {
            base.route = { ...(base.route || {}), ...componentConfig.route }
        }
        otherLang[componentName] = componentConfig
    }
    
    return { ...base, ...otherLang }
}
